
export class CustomPattern {
  name = '^[a-zA-Z0-9]{1}?[a-zA-Z0-9-_ ]*';
  address = /^[a-zA-Z0-9#\'.,-/][a-zA-Z0-9-_.,#/()"\' \[\]]*$/;
  phone = '^[0-9]';
  email = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
  specialCharName = '^[a-zA-Z0-9]{1}?[a-zA-Z0-9-_"/ ]*';
  specialChars = '^[^-]{1}?[^]*$';
  fiveDecimalPoints = '\\-?\\d*\\.?\\d{1,5}';
  twoDecimalPoints = '\\-?\\d*\\.?\\d{1,2}';
  threeDecimalPoints = '\\-?\\d*\\.?\\d{1,3}';
  alphaNumericPassword = '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$';
  password = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
  sixDecimalPoints = '\\-?\\d*\\.?\\d{0,6}';
  onlyAlpha = '^[a-zA-Z]*';
  onlyNumberPlusHyphen = '^[0-9+-]*$';
  alphaNumeric = '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$';
  numbersSpecialChars = '[0-9!@#$%^&*()-/,.?\":{}|<>]*';
}
